export enum ChannelType {
    DIGITAL_CONTACT = 1,
    DIGITAL_MOTOR = 2,

    ANALOG_420MA_PT = 21,
    ANALOG_420MA_AI = 22,
    ANALOG_1_5_V = 23,
    ANALOG_PT100_3WIRE = 24,
    ANALOG_PT100_2WIRE = 25,
    ANALOG_TEMP_K = 26,

    EXH_GAS_DEV = 31,
    EXH_GAS_MEAN = 32,

    FLOW_TOTAL = 41,
    FLOW_DAY = 42,

    RUNNING_TOTAL = 51,
    RUNNING_DAY = 52,

    BLANK = 100,

    SYSTEM_CHANNEL = 200,

    BLANK_FCU = 300,
}

export enum AlarmLevel {
    Caution,
    Warning,
    Alarm,

    None,
}

type DigitalType = ChannelType.DIGITAL_CONTACT | ChannelType.DIGITAL_MOTOR;

export function isChannelMotorType(type: ChannelType): type is ChannelType.DIGITAL_MOTOR {
    return type === ChannelType.DIGITAL_MOTOR;
}

export function isChannelDigitalType(type: ChannelType): type is DigitalType {
    return type === ChannelType.DIGITAL_CONTACT || isChannelMotorType(type);
}

const digitalTypes = new Set([ChannelType.DIGITAL_CONTACT, ChannelType.DIGITAL_MOTOR]);

export function isDigital(type: ChannelType) {
    return digitalTypes.has(type);
}

const runningHourTypes = new Set([ChannelType.RUNNING_TOTAL, ChannelType.RUNNING_DAY]);

export function isRunningHour(type: ChannelType) {
    return runningHourTypes.has(type);
}

export function isSystemChannelType(type: ChannelType) {
    return ChannelType.SYSTEM_CHANNEL == type;
}
